<template>
  <div class="main-container">
    <!-- <div class="banner">
      <h1>矩尺网络&nbsp;&nbsp;|&nbsp;&nbsp;应用场景</h1>
      <div class="title-devide-line"></div>
    </div> -->
    <!-- <div class="case-tabs-bar">
      <span class="case-tab" :class="{'is-active': activeTab === '服务器负载均衡'}" @click="activeTab = '服务器负载均衡'">服务器负载均衡</span>
      <span class="case-tab" :class="{'is-active': activeTab === '全局负载均衡'}" @click="activeTab = '全局负载均衡'">全局负载均衡</span>
      <span class="case-tab" :class="{'is-active': activeTab === '静态资源发布'}" @click="activeTab = '静态资源发布'">静态资源发布</span>
      <span class="case-tab" :class="{'is-active': activeTab === '第三方负载均衡纳管'}" @click="activeTab = '第三方负载均衡纳管'">第三方负载均衡纳管</span>
      <span class="case-tab" :class="{'is-active': activeTab === '安全协作'}" @click="activeTab = '安全协作'">安全协作</span>
    </div> -->
    <div class="case-tabs-content scene" v-if="activeTab === 'caseapi'">
      <aside>
        <ul>
          <li :class="{'is-active': activeAside === '基础负载均衡业务-HTTP/TCP'}" @click="activeAside='基础负载均衡业务-HTTP/TCP'"><svg-icon class="scene-icon" icon-class="scene" />基础负载均衡业务-HTTP/TCP</li>
          <li :class="{'is-active': activeAside === '基础负载均衡业务-SSL卸载'}" @click="activeAside='基础负载均衡业务-SSL卸载'"><svg-icon class="scene-icon" icon-class="scene" />基础负载均衡业务-SSL卸载</li>
          <li :class="{'is-active': activeAside === '服务器健康检查'}" @click="activeAside='服务器健康检查'"><svg-icon class="scene-icon" icon-class="scene" />服务器健康检查</li>
          <li :class="{'is-active': activeAside === '会话保持'}" @click="activeAside='会话保持'"><svg-icon class="scene-icon" icon-class="scene" />会话保持</li>
          <li :class="{'is-active': activeAside === '服务器温暖上线'}" @click="activeAside='服务器温暖上线'"><svg-icon class="scene-icon" icon-class="scene" />服务器温暖上线</li>
          <li :class="{'is-active': activeAside === '连接复用场景'}" @click="activeAside='连接复用场景'"><svg-icon class="scene-icon" icon-class="scene" />连接复用场景</li>
          <li :class="{'is-active': activeAside === '业务灰度发布管理'}" @click="activeAside='业务灰度发布管理'"><svg-icon class="scene-icon" icon-class="scene" />业务灰度发布管理</li>
          <li :class="{'is-active': activeAside === '按需定制分发策略'}" @click="activeAside='按需定制分发策略'"><svg-icon class="scene-icon" icon-class="scene" />按需定制分发策略</li>
        </ul>
      </aside>
      <main>
        <div class="case-tabs-content-main-wrap">
          <div class="case-tabs-content-main-content" v-show="activeAside==='基础负载均衡业务-HTTP/TCP'" >
            <div class="bg-text">场景1</div>
            <h2>基础负载均衡业务-HTTP/TCP</h2>
            <ul>
              <li>
                <span class="label icon-circle">SSL：</span>
                <span>业务访问环境无SSL加密\卸载需求；</span>
              </li>
              <li>
                <span class="label icon-circle">负载均衡算法：</span>
                <span>根据业务需要，将不同业务真实服务器池负载均衡算法设置为轮询、带权重的轮询、动态连接数、一致性hash算法等；</span>
              </li>
              <li>
                <span class="label icon-circle">服务器健康检查：</span>
                <span>根据业务需要，将不同业务真实服务器池健康检查策略设置为icmp、tcp、http；</span>
              </li>
              <li>
                <span class="label icon-circle">协议类型：</span>
                <span>根据业务需要，设置虚拟服务协议类型为TCP、HTTP；</span>
              </li>
              <li>
                <span class="label icon-circle">目的端口转换：</span>
                <span>无；</span>
              </li>
              <li>
                <span class="label icon-circle">源地址转换：</span>
                <span>源地址转换为虚拟服务IP；</span>
              </li>
              <li>
                <span class="label icon-circle">溯源：</span>
                <span>无；</span>
              </li>
              <li>
                <span class="label icon-circle">会话保持：</span>
                <span>无；</span>
              </li>
            </ul>
            <img src="@/assets/imgs/case-HttpTcp.png" width="602" height="280" style="transform: translate(190px, 50px);" alt="">
          </div>
          <div class="case-tabs-content-main-content" v-show="activeAside==='基础负载均衡业务-SSL卸载'" >
            <div class="bg-text">场景2</div>
            <h2>基础负载均衡业务-SSL卸载</h2>
            <ul>
              <li class="icon-squire">部署在服务器前端，实现明文数据与加密数据的转换，为外网用户构建安全的传输通道；</li>
              <li class="icon-squire">服务端应用无需做任何调整，减少开发人员工作量；</li>
              <li class="icon-squire">只需购买1对SSL卸载设备，服务器性能不下降，大幅节约硬件投资成本。</li>
            </ul>
            <img src="@/assets/imgs/case-SSL-unload.png" width="600" height="300" style="transform: translate(20px, 50px);" alt="" loading="lazy">
          </div>
          <div class="case-tabs-content-main-content" v-show="activeAside==='服务器健康检查'" >
            <div class="bg-text">场景3</div>
            <h2>服务器健康检查</h2>
            <ul>
              <li>
                <h4 class="icon-squire">健康检查</h4>
                <p>健康检查用来判断后台服务器存活状态。</p>
                <p class="icon-circle">特定的应用程序，一个续期的回复，在一定时间内。</p>
              </li>
              <li>
                <h4 class="icon-squire">失败后的处理动作</h4>
                <p class="icon-circle break-line">标记节点为异常，从现有资源池中剔除→继续进行探测→没有新连接到这个成员member，但现有连接被维持→达到了超时时间前有一个成功的检查结果新连接发送到节点。</p>
              </li>
              <li>
                <h4 class="icon-squire">复合健康监测</h4>
                <p>可以使用复合健康监测, 所以可使用多重健康检查。</p>
                <p class="icon-circle">可以使用全部或者部分的健康检查结果来标记成员的状态。</p>
              </li>
              <li>
                <h4 class="icon-squire">复合健康监测</h4>
                <p class="icon-circle">基于硬件运行状况的主动检查：通过PING、SNMP等方式监控服务器的运行状况；</p>
                <p class="icon-circle">基于应用类型的主动检查：TCP、UDP、HTTP、DNS等都可以通过相应的检测机制监控应用的运行状况；</p>
                <p class="icon-circle">自定义内容检查机制：是通过预设自定义脚本，来判断服务器应用是否运行正常;</p>
                <p class="icon-circle">基于观测方式的被动检查：根据观测到的服务器连接数，上下行数据报文。</p>
              </li>
            </ul>
            <img src="@/assets/imgs/case-health-check.png" width="750" height="260" style="transform: translate(20px, 0px);" alt="" loading="lazy">
          </div>
          <div class="case-tabs-content-main-content" v-show="activeAside==='会话保持'" >
            <div class="bg-text">场景4</div>
            <h2>会话保持</h2>
            <h4>提供全面的会话保持算法</h4>
            <ul>
              <li class="icon-squire">
                <span class="break-line">会话保持用以识别客户与服务器之间交互过程的关联性，在作负载均衡的同时，还保证一系列相关联的访问请求会保持分配到一台服务器上，以确保应用不会出错。</span>
              </li>
              <li class="icon-squire">
                <span class="break-line">支持的会话保持方式：基于源IP保持、Cookie（插入、被动、改写）、HTTP-Header、SSL Session ID。</span>
              </li>
              <li class="icon-squire">
                <span class="break-line">与应用系统无缝结合，保障业务连续性。</span>
              </li>
            </ul>
            <img src="@/assets/imgs/case-session-persistence.png" width="600" height="290" style="transform: translateX(20px);" alt="" loading="lazy">
          </div>
          <div class="case-tabs-content-main-content" v-show="activeAside==='服务器温暖上线'" >
            <div class="bg-text">场景5</div>
            <h2>服务器温暖上线</h2>
            <h4>新增服务器温暖上线</h4>
            <ul>
              <li class="icon-squire">
                <span class="break-line">将新购置或维护后的服务器添加到服务器组时，设备可以通过温暖上线方式，避免新服务器由于激增流量的冲击而导致系统故障，实现服务器的平滑进入。</span>
              </li>
              <li class="icon-squire">
                <span class="break-line">当新服务器上线后，在其恢复时间内，设备不会向该服务器发送请求；而在随后的温暖时间以内，设备则会逐渐地增加分配到该服务器地请求，使新服务器地压力缓慢增加到稳定状态，从而保证服务器在启动期间以及应用程序初始化时都能提供不间断服务。</span>
              </li>
            </ul>
            <img src="@/assets/imgs/case-worm-onload.png" width="600" height="330" style="transform: translate(150px, 50px);" alt="" loading="lazy">
          </div>
          <div class="case-tabs-content-main-content" v-show="activeAside==='连接复用场景'" >
            <div class="bg-text">场景6</div>
            <h2>连接复用场景</h2>
            <h4>提供基于连接的TCP复用机制</h4>
            <ul>
              <li class="icon-squire">
                <span class="break-line">通过将众多客户端连接请求捆绑后，复用相对较少的服务器TCP连接。</span>
              </li>
              <li class="icon-squire">
                <span class="break-line">不需要改变任何网络构造，也不需要增加组织的硬件投资成本。</span>
              </li>
              <li class="icon-squire">
                <span class="break-line">适用与大量的连接建立/拆卸的应用，减少服务器的工作负荷。</span>
              </li>
            </ul>
            <img src="@/assets/imgs/case-connection-reuse.png" width="500" height="232" style="transform: translate(0px, 0px);" alt="" loading="lazy">
          </div>
          <div class="case-tabs-content-main-content" v-show="activeAside==='业务灰度发布管理'" >
            <div class="bg-text">场景7</div>
            <h2>业务灰度发布管理</h2>
            <ul>
              <li>
                <h4 class="icon-squire">灰度流量管理</h4>
                <p class="break-line">可同时运行两个或多个版本（例如网站、APP应用），部分用户访问老版本，部分用户访问新版本，用以测试新版本问题、客户喜好度等。同时不需要中断业务来做调整。</p>
              </li>
              <li>
                <h4 class="icon-squire">根据用户IP地址区分</h4>
              </li>
              <li>
                <h4 class="icon-squire">根据版本权重区分</h4>
              </li>
              <li>
                <h4 class="icon-squire">根据cookie设置区分</h4>
              </li>
            </ul>
            <img src="@/assets/imgs/case-gated-launch.png" width="600" height="415" style="transform: translate(200px, 0px);" alt="" loading="lazy">
          </div>
          <div class="case-tabs-content-main-content" v-show="activeAside==='按需定制分发策略'" >
            <div class="bg-text">场景8</div>
            <h2>按需定制分发策略</h2>
            <ul>
              <li class="icon-squire break-line">在同一个虚拟服务内，可以创建多条具备不同优先级的分发规则，每条分发规则可以指定请求路由到不同的服务器池，亦或是返回重定向响应等。</li>
              <li class="icon-squire break-line">这样命中虚拟服务的请求就会根据分发规则转发不同的服务器池。其中，每条分发规则包含多条分发策略，而分发策略是基于源地址、URL、COOKIE等请求信息生效的。</li>
            </ul>
            <img src="@/assets/imgs/case-dispatch-strategy.png" width="800" height="438" style="transform: translate(10px, 50px);" alt="" loading="lazy">
          </div>
        </div>
      </main>
    </div>
    <div class="case-tabs-content" v-else-if="activeTab === 'caseglb'">
      <div class="case-tabs-content-main-wrap">
        <div class="case-tabs-content-main-content">
          <h2>全局负载均衡</h2>
          <ul>
            <li>
              <span class="icon-circle">可应用在多活或主备数据中心场景；</span>
            </li>
            <li>
              <span class="icon-circle">利用算法选择最佳站点并返回业务健康的服务IP；</span>
            </li>
            <li>
              <span class="icon-circle">提供DNS解析功能：</span>
              <ul class="sub-list">
                <li>&#10004; 支持A、AAAA、CNAME、NS、MX、TXT、PTR、SRV等多种类型DNS记录；</li>
                <li>&#10004; 对于A和AAAA记录的值可以指定服务器池，池内可以设置多种负载均衡算法，</li>
                <li>&#10004; 服务器节点既可以是静态地址，也可以选择SLB虚拟服务。</li>
              </ul>
            </li>
            <li>
              <span class="icon-circle">支持多种静态就近性：</span>
              <ul class="sub-list">
                <li>&#10004; 内置ISP、全球及国内多种地理位置库；</li>
                <li>&#10004; 支持自定义IP地址库；</li>
              </ul>
            </li>
            <li>
              <span class="icon-circle">支持链路健康检测；</span>
            </li>
            <li>
              <span class="icon-circle">支持SLB虚拟服务与DNS服务的深度结合；</span>
            </li>
          </ul>
          <img src="@/assets/imgs/global-lb.png" style="position: absolute;right: 200px;top: 0;" width="400" alt="全局负载均衡">
        </div>
      </div>
    </div>
    <div class="case-tabs-content" v-else-if="activeTab === 'caseunified'">
      <div class="case-tabs-content-main-wrap">
        <div class="case-tabs-content-main-content">
          <h2>第三方负载均衡纳管</h2>
          <ul>
            <li>
              <span class="icon-circle">支持对虚拟服务、服务器池统一监控，并可通过标签关联业务名称，聚合分析，方便基于业务查询各项数据；</span>
            </li>
            <li>
              <span class="icon-circle">支持对异常事件以图像方式产生告警，并可与微信、短信等第三方平台联动告警信息；</span>
            </li>
            <li>
              <span class="icon-circle">支持自动形成部署拓扑和业务服务拓扑，提高运维效率；</span>
            </li>
          </ul>
          <img src="@/assets/imgs/case-thirdload.png" alt="第三方负载均衡纳管">
        </div>
      </div>
    </div>
    <div class="case-tabs-content" v-else-if="activeTab === 'casesafe'">
      <div class="case-tabs-content-main-wrap">
        <div class="case-tabs-content-main-content">
          <h2>安全协作</h2>
          <div class="content-box">
            <div class="left-box">
              <ul class="sub-list">
                <li>&#10004; 在企业网络出口，同专业安全平台联动；</li>
                <li>&#10004; 通过OPENAPI与专业安全平台无缝协作；</li>
                <li>&#10004; 主动区分正常用户流量和潜在的攻击流量，并导流。</li>
              </ul>
              <img src="@/assets/imgs/case-safe-cooperation.png" width="600" style="padding-left: 23px;" alt="安全协作">
            </div>
            <div class="right-box">
              <ul>
                <li>
                  <span class="label icon-circle">蜜罐：</span>
                  <span>结合静态资源服务功能做蜜罐系统，分析攻击者的行为；</span>
                </li>
                <li>
                  <span class="label icon-circle">脚本注入：</span>
                  <span>可将应用服务器返回的某些HTML页面中注入JavaScript脚本，监测用户行为并收集信息；</span>
                </li>
                <li>
                  <span class="label icon-circle">源IP集合匹配：</span>
                  <span>匹配由更新到管理面的源IP集合，转发引擎可以根据规则处理请求；</span>
                </li>
                <li>
                  <span class="label icon-circle">报文处理、导流：</span>
                  <ul class="sub-list">
                    <li>&#10004; 转发引擎可按需直接丢弃攻击报文；</li>
                    <li>&#10004; 转发引擎可按需将攻击流量重定向到某个隔离的网络区域处理；</li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="case-tabs-content" v-else-if="activeTab === 'caseaitraffic'">
      <div class="case-tabs-content-main-wrap">
        <div class="case-tabs-content-main-content" style="height: 500px;">
          <h2>基于AI应用的多模型流量治理</h2>
          <h3>针对多种AI应用的快速业务对接，多大模型的灵活接入和流量高可用场景。</h3>
          <ul style="width: 500px;">
            <li>
              <span class="label icon-circle">建立弹性、高效率的多模型架构：</span>
              <span style="display: block;padding-left: 23px;">满足多种大模型平台的横向扩展需求，建立多模型架构，实现智能流量均担调度，提升大模型使用效率；</span>
            </li>
            <li>
              <span class="label icon-circle">实现内容安全合规：</span>
              <span style="display: block;padding-left: 23px;">利用技术手段实现敏感信息脱敏和合规处理，满足内容安全需求；</span>
            </li>
            <li>
              <span class="label icon-circle">多维度的高效运维：</span>
              <span style="display: block;padding-left: 23px;">基于大模型业务流量的多维度可观测运维视图，提高运维效率，满足故障快速定位与流量统计分析需求；</span>
            </li>
          </ul>
          <img src="@/assets/imgs/case-ai-traffic.png" style="position: absolute;right: 0px;top: 0;" width="680" alt="基于AI应用的多模型流量治理">
        </div>
      </div>
    </div>
    <div class="case-tabs-content" v-else-if="activeTab === 'casecloud'">
      <div class="case-tabs-content-main-wrap">
        <div class="case-tabs-content-main-content">
          <h2>多维流量治理与云原生架构演进</h2>
          <h3>针对企业级 AI 算力分配、等保合规审计及传统架构升级，提供全栈可视化、高可靠的流量引擎方案。</h3>
          <ul class="function-list">
            <li>
              <span class="icon-circle function-title">多部门 AI 算力平滑接入与配额隔离：</span>
              <ul class="sub-list">
                <li>
                  <span class="function-label"><span>&#10004; </span>可视化网关配置：</span>
                  <span class="function-content">告别复杂的 YAML 编写，管理员通过 Web 控制台即可直观配置 Gateway 规则，大幅提升运维效率并降低出错率；</span>
                </li>
                <li>
                  <span class="function-label"><span>&#10004; </span>弹性实例管理：</span>
                  <span class="function-content">支持手动指定 Gateway 实例数，确保在高并发场景下，网关层具备卓越的转发韧性与确定性；</span>
                </li>
                <li>
                  <span class="function-label"><span>&#10004; </span>流量拓扑可视化：</span>
                  <span class="function-content">实时清晰展现从各部门业务到虚拟服务、再到具体模型推理组的流量全路径，实现业务指标与算力消耗的一眼洞察。</span>
                </li>
              </ul>
            </li>
            <li>
              <span class="icon-circle function-title">等保合规下的全链路流量审计与安全治理：</span>
              <ul class="sub-list">
                <li>
                  <span class="function-label"><span>&#10004; </span>全栈可视化安全管理：</span>
                  <span class="function-content">针对金融、政府等高合规要求场景，提供图形化配置界面，实现对进入 K8s 集群流量的7 层协议分析与实时监测；</span>
                </li>
                <li>
                  <span class="function-label"><span>&#10004; </span>深度溯源与抓包：</span>
                  <span class="function-content">内置“全链路数据抓包”功能，支持安全事件的快速定位与合规性溯源，满足等保 2.0 对日志留存与流量监测的刚性需求；</span>
                </li>
                <li>
                  <span class="function-label"><span>&#10004; </span>智能事件告警：</span>
                  <span class="function-content">基于流量状态自动识别异常突发或非法访问，并实时推送告警，构建从管理面到数据面的闭环安全体系。</span>
                </li>
              </ul>
            </li>
            <li>
              <span class="icon-circle function-title">传统架构向云原生容器化的“零抖动”迁移：</span>
              <ul class="sub-list">
                <li>
                  <span class="function-label"><span>&#10004; </span>物理与虚拟网络跨域互通：</span>
                  <span class="function-content">利用转发引擎内置的动态路由协议，打通物理网络与 Pod 网络屏障，实现容器化应用与传统业务的无缝通信；</span>
                </li>
                <li>
                  <span class="function-label"><span>&#10004; </span>全场景流量接管：</span>
                  <span class="function-content">矩尺引擎作为集群流量枢纽，统一管控南北向与东西向流量，确保迁移过程中链路始终可控、可监测；</span>
                </li>
                <li>
                  <span class="function-label"><span>&#10004; </span>平滑切换机制：</span>
                  <span class="function-content">通过精细化的流量控制策略，确保业务在架构演进过程中实现“零抖动”迁移，保障核心业务的连续性。</span>
                </li>
              </ul>
            </li>
          </ul>
          <div>
            <img src="@/assets/imgs/product-center-normaecloud.png" width="830" alt="多维流量治理与云原生架构演进">
          </div>
        </div>
      </div>
    </div>
    <div class="case-tabs-content" v-else>
      <div class="case-tabs-content-main-wrap">
        <div class="case-tabs-content-main-content">
          <h2>静态资源托管与发布（替换Nginx业务的自主可控解决方案）</h2>
          <ul>
            <li>
              <span class="label icon-circle">支持静态资源发布（即WEB服务器）功能，例如html、js、css、image等的展示；</span>
            </li>
            <li>
              <span class="label icon-circle">支持文件资源管理：</span>
              <span>.tar.gz或者.zip两种压缩包格式；后续更改部分文件或者目录时，可以单个新增、删除；</span>
            </li>
            <li>
              <span class="label icon-circle">支持高可用：</span>
              <span>管理节点可保存静态资源，在静态资源列表页中可显示相关转发引擎的同步状态；</span>
            </li>
            <li>
              <span class="label icon-circle">支持Minetype映射：</span>
              <span>每个静态资源都可以独立配置mimetype，并可以配置默认minetype；</span>
            </li>
            <li>
              <span class="label icon-circle">支持图形化：</span>
              <span>静态资源将以树状图形化展示；</span>
            </li>
            <li>
              <span class="label icon-circle">支持2种URL映射关系：</span>
              <span>完全映射与去URL映射；</span>
            </li>
            <li>
              <span class="label icon-circle">支持首页文件：</span>
              <span>可自动或手动配置首页文件；</span>
            </li>
            <li>
              <span class="label icon-circle">支持预压缩功能：</span>
              <span>支持GZIP和BROTLI预压缩；</span>
            </li>
          </ul>
          <h2>方案优势</h2>
          <ul>
            <li>
              <span class="label icon-circle">高可用性：</span>
              <span>支持集群部署，统一管理；</span>
            </li>
            <li>
              <span class="label icon-circle">操作便捷：</span>
              <span>中文GUI管理界面，可通过Web和命令行配置；</span>
            </li>
            <li>
              <span class="label icon-circle">灵活的流量调度：</span>
              <span>支持多样的分发策略和分发规则，灵活调度数据流；</span>
            </li>
            <li>
              <span class="label icon-circle">业务连续性：</span>
              <span>支持多种算法和会话保持机制，保障业务流畅运行；</span>
            </li>
            <li>
              <span class="label icon-circle">实时服务状态感知：</span>
              <span>支持多协议自动健康检查，动态感知服务器服务状态；</span>
            </li>
            <li>
              <span class="label icon-circle">多租户管理体系：</span>
              <span>基于RTBAC（用户、角色、租户）的自助服务管理体系，实现分权管理和负载资源的高效利用；</span>
            </li>
            <li>
              <span class="label icon-circle">运维便捷：</span>
              <span>自动形成虚拟服务拓扑，图形化文件管理界面；</span>
            </li>
            <li>
              <span class="label icon-circle">开放的接口：</span>
              <span>丰富的OPENAPI接口，可灵活对接第三方平台；</span>
            </li>
          </ul>
          <img src="@/assets/imgs/case-static-resource.png" style="position: absolute;right: 40px;top: 0;" width="480" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitlePoint from '@/components/TitlePoint.vue'
export default {
  components: {
    TitlePoint
  },
  data() {
    return {
      activeAside: '基础负载均衡业务-HTTP/TCP'
    }
  },
  computed: {
    activeTab() {
      return (this.$route.hash || '#casestatic').substring(1)
    },
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.banner{
  height: 185px;
  background-image: url('~@/assets/imgs/case-top-bg.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  h1 {
    margin-bottom: 10px;
  }
  .title-devide-line{
    width: 155px!important;
  }
}
.case-tabs-bar{
  display: flex;
  align-items: center;
  padding: 20px 0;
  .case-tab{
    color: #555555;
    display: inline-block;
    font-size: 15px;
    margin-left: 100px;
    padding: 8px 30px;
    border-radius: 18px;
    box-sizing: border-box;
    cursor: pointer;
    &.is-active {
      background-color: $primaryColor;
      color: #fff;
    }
  }
}
.case-tabs-content{
  background-color: #fff;
  padding: 50px;
  &.scene {
    display: flex;
    aside ul li{
      width: 302px;
      text-align: left;
      box-sizing: border-box;
      color: #868686;
      height: 60px;
      line-height: 60px;
      padding: 0 30px 0 20px;
      border-top: 1px solid #c4c4c4;
      display: flex;
      align-items: center;
      cursor: pointer;
      &:last-child {
        border-bottom: 1px solid #c4c4c4;
      }
      &.is-active {
        color: $primaryColor;
        font-weight: 700;
        background-color: #fbebe0;
        position: relative;
        &::after {
          content: '';
          display: block;
          position: absolute;
          right: 0;
          bottom: 50%;
          transform: translateY(50%);
          border: 12px solid transparent;
          border-right-color: #fff;
        }
      }
      .scene-icon {
        width: 30px;
        height: 30px;
        display: inline-block;
        margin-right: 10px;
      }
    }
    main {
      flex: 1;
      .case-tabs-content-main-wrap {
        padding: 50px 80px;
        text-align: left;
        counter-reset: count;
        .case-tabs-content-main-content {
          position: relative;
          counter-increment: count;
          .bg-text{
            position: absolute;
            color: #f5f5f5;
            top: -80px;
            font-weight: 700;
            font-size: 85px;
          }
          h2 {
            position: relative;
            z-index: 1;
            font-size: 22px;
            color: #333333;
            margin: 20px 40px;
          }
          h4{
            margin: 20px 0;
            line-height: 1.5;
          }
          p{
            line-height: 1.5;
            margin: 20px 23px;
          }
          li{
            line-height: 1.5;
            margin: 20px 0;
            white-space: nowrap;
            .label{
              display: inline-block;
              width: 130px;
            }
          }
          .break-line{
            white-space: normal;
          }
          .icon-squire{
            position: relative;
            padding-left: 23px;
            &::before{
              content: '';
              display: block;
              position: absolute;
              top: 4px;
              left: 0;
              box-sizing: border-box;
              width: 13px;
              height: 13px;
              border: 2px solid $primaryColor;
              margin-right: 10px;
            }
          }
          .icon-circle{
            position: relative;
            padding-left: 23px;
            &::before{
              content: '';
              display: block;
              position: absolute;
              top: 6px;
              left: 0;
              box-sizing: border-box;
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: $primaryColor;
              margin-right: 10px;
            }
          }
        }
      }
    }
  }
  .case-tabs-content-main-wrap {
    text-align: left;
    counter-reset: count;
    .case-tabs-content-main-content {
      position: relative;
      counter-increment: count;
      .bg-text{
        position: absolute;
        color: #f5f5f5;
        top: -80px;
        font-weight: 700;
        font-size: 85px;
      }
      h2 {
        position: relative;
        z-index: 1;
        font-size: 26px;
        font-weight: bold;
        color: #333333;
        margin: 20px 0px;
      }
      p{
        line-height: 1.5;
        margin: 20px 23px;
      }
      .break-line{
        white-space: normal;
      }
      li{
        line-height: 1.5;
        margin: 20px 0;
        white-space: normal;
        .label{
          display: inline-block;
          font-weight: bolder;
        }
        span{
          display: inline-flex;
          white-space: normal;
        }
      }
      .icon-circle{
        position: relative;
        padding-left: 23px;
        &::before{
          content: '';
          display: block;
          position: absolute;
          top: 6px;
          left: 0;
          box-sizing: border-box;
          width: 10px;
          height: 10px;
          border-radius: 50%;
          background-color: $primaryColor;
          margin-right: 10px;
        }
      }
      .content-box{
        display: flex;
        .left-box{
          width: 49%;
        }
        .right-box{
          flex: 1;
        }
      }
      .sub-list{
        padding-left: 23px;
      }
    }
    .function-list{
      line-height: 2;
      .function-title{
        font-size: 18px;
        font-weight: bold;
      }
      .function-label{
        font-weight: bold;
        &>span:nth-child(1){
          padding-right: 6px;
        }
      }
      .function-content{
        // width: 400px;
      }
    }
  }
  
}
</style>